import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { AxiosResponse, AxiosStatic, InternalAxiosRequestConfig } from "axios";
import { loginRequest } from "../app/authentication/msalConfig";

async function getToken(msalInstance: any) {
  try {
    const token = await msalInstance.acquireTokenSilent(loginRequest);
    return token.idToken;
  } catch (error) {
    if (error instanceof InteractionRequiredAuthError) {
      msalInstance.acquireTokenRedirect(loginRequest)
    }
    return null;
  }
}

export default function setupAxios(axios: AxiosStatic, msalInstance: any) {
  
  // 1. REQUEST INTERCEPTOR
  axios.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
      const authToken = await getToken(msalInstance);
      if (authToken) {
        config.headers.Authorization = `Bearer ${authToken}`;
      }
      return config;
    },
    (err) => Promise.reject(err)
  );

  // 2. RESPONSE INTERCEPTOR (The fix for 401s)
  axios.interceptors.response.use(
    (response: AxiosResponse) => response, // Pass through successful responses
    async (error) => {
      const originalRequest = error.config;      
      // Check if the error is 401 and we haven't retried this request yet
      console.log(error);
      console.log(originalRequest);
      if (error.response?.status === 401 && !originalRequest._retry) {        
        originalRequest._retry = true; // Mark to avoid infinite loops

        try {
          // Force a silent token refresh (passing true to skip cache if your getToken supports it)
          const newToken = await getToken(msalInstance); 

          if (newToken) {
            // Update the header and retry the original call
            originalRequest.headers.Authorization = `Bearer ${newToken}`;
            return axios(originalRequest);
          }
        } catch (refreshError) {
          return Promise.reject(refreshError);
        }
      }

      return Promise.reject(error);
    }
  );
}